import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Icon from '@mui/material/Icon';

import {
    useDataGridStyles,
    formatTime,
    MAX_ROWS,
    dateComparator,
} from './datagridutil';

function CredentialTable(props) {
    const { credentials, onRemoveCredential } = props;
    const classes = useDataGridStyles();

    if (!(credentials?.length > 0)) {
        return null;
    }

    const renderRemove = (params) => {
        return (
            <Tooltip title={''}>
                <span>
                    <IconButton
                        key="remove"
                        aria-label="Remove"
                        color="inherit"
                        onClick={(event) => {
                            onRemoveCredential &&
                                onRemoveCredential(params.value);
                            event.stopPropagation();
                        }}
                        size="large"
                    >
                        <Icon>delete</Icon>
                    </IconButton>
                </span>
            </Tooltip>
        );
    };

    const autoHeight = credentials.length <= MAX_ROWS;

    const columns = [
        { field: 'id', headerName: 'ID', width: 65 },
        { field: 'type', headerName: 'Type', flex: 1 },
        { field: 'externalId', headerName: 'External ID', flex: 1 },
        {
            field: 'createdAt',
            headerName: 'Created',
            width: 100,
            valueGetter: formatTime,
            sortComparator: dateComparator,
        },
        {
            field: 'updatedAt',
            headerName: 'Updated',
            width: 100,
            valueGetter: formatTime,
            sortComparator: dateComparator,
        },
        {
            field: 'remove',
            headerName: '',
            width: 58,
            renderCell: renderRemove,
            valueGetter: (params) => params.row.id,
        },
    ];

    return (
        <Paper
            className={classes.root}
            sx={{ height: autoHeight ? undefined : 93 + MAX_ROWS * 36 }}
        >
            <DataGrid
                autoHeight={autoHeight}
                rows={credentials}
                columns={columns}
                hideFooter={autoHeight}
                hideFooterSelectedRowCount
                isRowSelectable={() => false}
                className={
                    autoHeight ? classes.dataGridAutoHeight : classes.dataGrid
                }
                density="compact"
            />
        </Paper>
    );
}

export default CredentialTable;
